'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

var _without = require('lodash/without');

var _without2 = _interopRequireDefault(_without);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EnterLeaveCounter = function () {
  function EnterLeaveCounter() {
    _classCallCheck(this, EnterLeaveCounter);

    this.entered = [];
  }

  _createClass(EnterLeaveCounter, [{
    key: 'enter',
    value: function enter(enteringNode) {
      var previousLength = this.entered.length;

      var isNodeEntered = function isNodeEntered(node) {
        return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
      };

      this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);

      return previousLength === 0 && this.entered.length > 0;
    }
  }, {
    key: 'leave',
    value: function leave(leavingNode) {
      var previousLength = this.entered.length;

      this.entered = (0, _without2.default)(this.entered.filter(function (node) {
        return document.documentElement.contains(node);
      }), leavingNode);

      return previousLength > 0 && this.entered.length === 0;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.entered = [];
    }
  }]);

  return EnterLeaveCounter;
}();

exports.default = EnterLeaveCounter;


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/~/react-dnd-html5-backend/lib/EnterLeaveCounter.js
// module id = 593
// module chunks = 0